import React from 'react';
import { useNavigate } from 'react-router-dom';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import '../styles/ProductionDashboard.css';
import Calender from './calender';
import EditingPage from './EditingPage';
import ProgressTracker from './progressTracker';
import { baseUrl } from '../config';



export default function ProductionDashboard() {
  const navigate = useNavigate();

  return (
    <>
    <SEO
      title="Production Dashboard"
      description="Monitor and manage your film's active production phase — shoots, crew, locations, and daily progress — all in ProducerBuddy's production dashboard."
      url="https://producerbuddy.pilomation.com/production-dashboard"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <main id="preProduction">
      <div id="dashboardTitle">
        <h1>Production Dashboard</h1>
        <p id="welcomeMessage">Welcome back!</p>
      </div>
      <div id="mainCardWrapper">
        <div
          id="scriptAnalysis"
          onClick={() => navigate('/tracker')}
          role="button"
          tabIndex={0}
        >
          <h2>Progress tracker</h2>
          <ProgressTracker />
        </div>
        <div
          id="castWrapper"
          onClick={() => navigate('/calender')}
          role="button"
          tabIndex={0}
        >
          <h2>Calender</h2>
          <Calender />
        </div>
        <div
          id="budgetWrapper"
          onClick={() => navigate('/editing')}
          role="button"
          tabIndex={0}
        >
          <h2>EditingPage</h2>
          <EditingPage />
        </div>
      </div>
    </main>
    </>
  );
}

